import type { CoworkWorkspaceAgent } from "./api"

export function selectDefaultCoworkAgent(
  agents: CoworkWorkspaceAgent[],
  defaultAgentID: string | undefined,
  scope: { companyID: string; projectID: string },
) {
  const available = agents.filter(
    (agent) =>
      agent.status === "active" &&
      agent.assignments.some(
        (assignment) =>
          assignment.scope_type === "workspace" ||
          (assignment.scope_type === "entity" && assignment.scope_id === scope.companyID) ||
          (assignment.scope_type === "project" && assignment.scope_id === scope.projectID),
      ),
  )
  return (
    available.find((agent) => agent.id === defaultAgentID) ??
    available.find((agent) => agent.template_id === defaultAgentID) ??
    available[0]
  )
}

export function selectAssignedCoworkAgentByTemplate(
  agents: CoworkWorkspaceAgent[],
  templateID: string,
  scope: { companyID: string; projectID: string },
  preferredAgentID?: string,
) {
  const available = agents.filter(
    (agent) =>
      agent.template_id === templateID &&
      agent.status === "active" &&
      agent.assignments.some(
        (assignment) =>
          assignment.scope_type === "workspace" ||
          (assignment.scope_type === "entity" && assignment.scope_id === scope.companyID) ||
          (assignment.scope_type === "project" && assignment.scope_id === scope.projectID),
      ),
  )
  const rank = (agent: CoworkWorkspaceAgent) => {
    if (agent.assignments.some((assignment) => assignment.scope_type === "project" && assignment.scope_id === scope.projectID)) return 0
    if (agent.assignments.some((assignment) => assignment.scope_type === "entity" && assignment.scope_id === scope.companyID)) return 1
    return 2
  }
  return available.find((agent) => agent.id === preferredAgentID) ??
    available.toSorted((left, right) => rank(left) - rank(right) || left.id.localeCompare(right.id))[0]
}
